<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">CP Meeting Details</a>
      </nav>
    </div>

    <div class="inner-page animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card">
                      <div class="card-header">
                            <div class="row">
                                <div class="col-12" v-if="MyCpMeetingDetails.broker_firm_name">
                                    <span class="lead-title">{{MyCpMeetingDetails.broker_firm_name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6" v-if="MyCpMeetingDetails.broker_name">
                                    <span class="enq-title">Broker</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.broker_name}}</span>
                                </div>
                                <div class="col-6" v-if="MyCpMeetingDetails.project_name">
                                    <span class="enq-title">Project Name</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.project_name}}</span>
                                </div>
                                <div class="col-6" v-if="MyCpMeetingDetails.assigned_to">
                                    <span class="enq-title">Assigned To</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.assigned_to}}</span>
                                </div>
                                <div class="col-6" v-if="MyCpMeetingDetails.created_by">
                                    <span class="enq-title">Created By</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.created_by}}</span>
                                </div>
                                <div class="col-6" v-if="MyCpMeetingDetails.meeting_schedule_date">
                                    <span class="enq-title">Meeting Schedule Date</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.meeting_schedule_date}}</span>
                                </div>
                                <div class="col-6" v-if="MyCpMeetingDetails.created_at">
                                    <span class="enq-title">Created At</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.created_at}}</span>
                                </div>
                                <div class="col-6" v-if="MyCpMeetingDetails.is_flagged">
                                  <span class="enq-title">Is Flagged</span>
                                  <span class="enq-details">{{MyCpMeetingDetails.is_flagged}}</span>
                                </div>
                                  <div class="col-6" v-if="MyCpMeetingDetails.status_id">
                                    <span class="enq-title">Status</span>
                                    <span class="enq-details">{{MyCpMeetingDetails.status_id}}</span>
                                </div>
                            </div>
                            <div class="row">
                              <div class="col-12" v-if="MyCpMeetingDetails.comment">
                                <span class="enq-title">Comment</span>
                                <span class="enq-details">{{MyCpMeetingDetails.comment}}</span>
                              </div>
                            </div>
                         
                        </div>
                      
                    </div>
            <!-- <div class="card-btn">
                <div class="col-12 pl-2 mb-3">
                  <router-link class="btn btn-white btn-block" :to="{ name: 'EditMyCpMeeting', params: { id: MyCpMeetingDetails.id }}">
                    <span class="center-fix">
                      <img src="@/assets/edit-orange.svg" alt="" class="mr-1\" />Edit
                    </span>
                  </router-link>
                </div>
              </div> -->
            </div>
          </div>
        </div>
    </div>
</div>

</template>
<script>
export default {
  name: 'MyCpMeetingDetails',
  data() {
    return {
      MyCpMeetingDetails: {},
      queryP: {},
      isFromMyCpMeeting: false,
    }
  },
  created () {
    this.isFromMyCpMeeting = JSON.parse(sessionStorage.getItem("isFromMyCpMeeting"));
    this.FetchMyCpMeetingDetails()
  },
  methods: {
    FetchMyCpMeetingDetails() {
      this.queryP['id'] = this.$route.params.id;
        this.$axios.get(`cp_meeting_requests/${this.queryP.id}`).then((res) => {
          this.MyCpMeetingDetails =  res.data.cp_meeting
        });
    },
  }
}
</script>
<style scoped>
    .inner-page{
        margin-top: 60px;
    }
    .selfie-image{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-outline {
      padding: 12px;
      color: #19a7ce;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.56px;
      display: flex;
      gap: 6px;
      justify-content: center;
      align-items: center;
      width: 50%;
      border-radius: 34px;
      border: 1px solid #19a7ce;
      background: #fff;
    }

    .selfie-toggle{
        padding-left: 0;
    }
    .selfie-image-background{
        background: url('~@/assets/no-avatar.svg') no-repeat 0px center  #fff;
        min-height: 100px;
        min-width: 100px;
    }
</style>